import Layout from '@/layout/index.vue'
export const boardManage = [
  {
    path: '/editBoard',
    activeMenu: '/editBoard',
    resourceId: '18',
    parentId: null,
    meta: {
      title: '编辑看板',
      icon: 'admin_back',
      activeMenu: '/editBoard',
      menu: true,
      sort: 100
    },
    component: Layout,
    children: [
      {
        path: '/editBoard/edit-sub-radar-board',
        name: '/editBoard/edit-sub-radar-board',
        resourceId: '1808',
        parentId: '18',
        component: () => import(/* webpackChunkName: "edit-sub-radar-board'" */ '@/views/manage/dashBi/radarManage.vue'),
        meta: {
          title: '市场雷达编辑',
          icon: 'el-icon-s-platform',
          activeMenu: '/editBoard/edit-sub-radar-board',
          routerBase: '/editBoard/edit-sub-radar-board'
        }
      },
      {
        path: '/editBoard/edit-sub-radar-board/*',
        name: '/editBoard/edit-sub-radar-board',
        resourceId: '1808',
        parentId: '18',
        component: () => import(/* webpackChunkName: "edit-sub-radar-board'" */ '@/views/manage/dashBi/radarManage.vue'),
        meta: {
          title: '市场雷达编辑',
          icon: 'el-icon-s-platform',
          activeMenu: '/editBoard/edit-sub-radar-board',
          routerBase: '/editBoard/edit-sub-radar-board',
          hidden: true
        }
      },
      {
        path: '/editBoard/edit-sub-house-board',
        name: '/editBoard/edit-sub-house-board',
        resourceId: '1808',
        parentId: '18',
        component: () => import(/* webpackChunkName: "edit-sub-house-board'" */ '@/views/manage/dashBi/houseManage.vue'),
        meta: {
          title: '房产看板编辑',
          icon: 'el-icon-s-platform',
          activeMenu: '/editBoard/edit-sub-house-board',
          routerBase: '/editBoard/edit-sub-house-board'
        }
      },
      {
        path: '/editBoard/edit-sub-house-board/*',
        name: '/editBoard/edit-sub-house-board',
        resourceId: '1808',
        parentId: '18',
        component: () => import(/* webpackChunkName: "edit-sub-house-board'" */ '@/views/manage/dashBi/houseManage.vue'),
        meta: {
          title: '房产看板编辑',
          icon: 'el-icon-s-platform',
          activeMenu: '/editBoard/edit-sub-house-board',
          routerBase: '/editBoard/edit-sub-house-board',
          hidden: true
        }
      },
    ]
  }
]
